module.exports = __webpack_public_path__ + "img/Nora-Logo_dark.99653e.svg";